import {
  DiscountType,
  PaymentCategory,
  PaymentChannel,
  PaymentMethod,
  PaymentStatus,
} from "common/enum/PaymentTypes";
import { I18N_KEYS } from "common/i18n/keys";
import { TextBody3, TextLabel } from "common/components";
import { StyledLink } from "common/components/Etc/StyledLink";
import { formatNumber, formatPrice } from "common/utils/stringUtil";

export const SALES_LIST_COLUMNS = [
  {
    key: "paymentAt",
    label: I18N_KEYS.sales.detail.table.date,
    ratio: 10,
    render: (value) => value?.replace("T", " ").slice(0, 19) ?? "-",
  },
  {
    key: "paymentTrxId",
    label: I18N_KEYS.sales.detail.table.paymentId,
    ratio: 10,
    isEllipsis: true,
    render: (value, row, { openDetailModal }) => (
      <StyledLink onClick={() => openDetailModal(row.id)}>{value}</StyledLink>
    ),
  },
  {
    key: "category",
    label: I18N_KEYS.sales.detail.table.category,
    ratio: 10,
    render: (value, _, { t }) => t(PaymentCategory[value]) ?? "-",
  },
  {
    key: "items",
    label: I18N_KEYS.sales.detail.table.item,
    ratio: 10,
    render: (items) => {
      if (!items || items.length === 0) return "-";
      return (
        <span style={{ display: "flex", justifyContent: "center" }}>
          {items[0]?.itemName ?? "-"}
          {items.length > 1 && <TextBody3>+{items.length - 1}</TextBody3>}
        </span>
      );
    },
  },
  {
    key: "items_qty",
    label: I18N_KEYS.sales.detail.table.qty,
    ratio: 3,
    render: (_, row) =>
      formatNumber(row.items?.reduce((acc, i) => acc + i.quantity, 0)) ?? "-",
  },
  {
    key: "totalAmount",
    label: I18N_KEYS.sales.detail.table.totalAmount,
    ratio: 9,
    render: (value) => formatPrice(value),
  },
  {
    key: "actualAmount",
    label: I18N_KEYS.sales.detail.table.amountPaid,
    ratio: 9,
    render: (value) => formatPrice(value),
  },
  {
    key: "discounts",
    label: I18N_KEYS.sales.detail.table.discountType,
    ratio: 10,
    render: (discounts, _, { t }) =>
      discounts?.map((d) => t(DiscountType[d.discountType])).join(" + ") || "-",
  },
  {
    key: "paymentMethod",
    label: I18N_KEYS.sales.detail.table.method,
    ratio: 10,
    render: (value, _, { t }) => t(PaymentMethod[value]) ?? "-",
  },
  {
    key: "status",
    label: I18N_KEYS.sales.detail.table.status,
    ratio: 10,
    render: (value, _, { t }) => {
      const status = PaymentStatus[value];
      return status ? (
        <TextLabel color={status.color}>{t(status.text)}</TextLabel>
      ) : (
        "-"
      );
    },
  },
  {
    key: "paymentPath",
    label: I18N_KEYS.sales.detail.table.channel,
    ratio: 10,
    render: (value, _, { t }) => t(PaymentChannel[value]) ?? "-",
  },
];
